import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import TargetSection from '../components/Target';

const Target = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <Header />
      <main className="pt-20">
        <TargetSection />
      </main>
      <Footer />
    </div>
  );
};

export default Target;
